export const downloadAction = ({ url }) => {
  const element = document.createElement('a')
  element.href = url
  document.body.appendChild(element)
  element.click()
}
